var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserprofile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59295",
    "data-name": "Group 59295",
    transform: "translate(-37 -173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64109",
    "data-name": "Path 64109",
    d: "M0,0H125V125H0Z",
    transform: "translate(37 173)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-regular-circle-user",
    "data-name": "Icon fa-regular-circle-user",
    d: "M59.546,58.535a18.76,18.76,0,0,0-17.358-11.66H32.813a18.76,18.76,0,0,0-17.358,11.66,30.469,30.469,0,1,1,44.092,0Zm-5.874,4.79a30.508,30.508,0,0,1-32.358,0,11.726,11.726,0,0,1,11.5-9.419h9.375a11.726,11.726,0,0,1,11.5,9.419ZM37.5,75A37.5,37.5,0,1,0,0,37.5,37.5,37.5,0,0,0,37.5,75Zm0-39.844A5.859,5.859,0,1,1,43.359,29.3,5.859,5.859,0,0,1,37.5,35.156ZM24.609,29.3A12.891,12.891,0,1,0,37.5,16.406,12.891,12.891,0,0,0,24.609,29.3Z",
    transform: "translate(62 198)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserprofile);
export default __webpack_public_path__ + "static/media/userprofile.47fc0e3162175e7eed2cf7d5a6507953.svg";
export { ForwardRef as ReactComponent };